import styled, { css } from 'styled-components';
import {
  popeyesNeutral,
  popeyesPrimaryColors,
  popeyesSecondaryColors,
  spacings,
  transitions,
  font,
  breakpoints,
} from 'styles';

import * as T from './interfaces';

interface Istatus {
  statusStore: 'active' | 'inactive';
}

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-width: 250px;
  max-width: 400px;
  width: 100%;

  padding: 0 ${spacings.space02};

  button {
    width: 100%;
  }
`;
const WrapperInfoFormatter = () => css`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;
export const HeaderInfo = styled.div`
  ${WrapperInfoFormatter()}

  h6 {
    margin-right: ${spacings.space05};
    text-align: initial;
  }

  > span {
    white-space: nowrap;
    margin: 0;
  }
`;
export const PrimariesInfo = styled.div<T.IItemStyles>`
  ${WrapperInfoFormatter()}

  margin: ${spacings.space03} 0 ${spacings.space02} 0;

  span + {
    font-size: ${font.sizes.textMedium};
    margin-left: 5px;
  }

  width: ${props => (props.statusStore === 'active' ? '80%' : '100%')};
`;

export const PointSeparator = styled.div`
  width: 7px;
  height: 7px;
  background-color: ${popeyesNeutral.neutral06};
  border-radius: 50%;
  margin: 0 5px;
`;

const StarFormatter = () => css`
  clip-path: polygon(
    50% 0%,
    67% 30%,
    96% 35%,
    74% 61%,
    80% 91%,
    50% 77%,
    19% 91%,
    26% 58%,
    2% 35%,
    34% 30%
  );
`;

const StarModifier = {
  favorite: (isFavorite: boolean) => css`
    opacity: ${isFavorite ? 1 : 0.6};
    div {
      background: ${isFavorite
        ? popeyesPrimaryColors.secondary
        : popeyesSecondaryColors.light};
    }
  `,
};

export const Star = styled.div<T.IStar>`
  ${StarFormatter()}
  width: 43px;
  height: 43px;
  background: ${popeyesPrimaryColors.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${transitions.opacity01};

  div {
    ${StarFormatter()}
    transition: ${transitions.background01};
    width: 30px;
    height: 30px;
  }

  ${({ isFavorite }) => css`
    ${StarModifier.favorite(isFavorite)}
  `}
`;

export const Address = styled.p`
  font-size: ${font.sizes.textMedium};
  line-height: ${font.lineHeight.medium};
  color: ${popeyesNeutral.neutral06};
`;

export const OpenGps = styled.div`
  > button {
    display: flex;
    justify-content: initial;
    align-items: initial;
    width: 100%;
  }

  margin: ${spacings.space00} 0;
`;

export const OpeningHoursList = styled.ul`
  list-style: none;
  padding: 0;
  width: 100%;
  margin: ${spacings.space02} 0;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;

    span {
      font-size: ${font.sizes.textMedium};
      line-height: ${font.lineHeight.xSmall};
      color: ${popeyesNeutral.neutral08};

      strong {
        font-weight: ${font.weight.semiBold};
        color: ${popeyesSecondaryColors.dark};
      }
    }
  }
`;

export const Advertence = styled.span`
  color: ${popeyesNeutral.neutral06};
  line-height: ${font.lineHeight.medium};
  font-size: ${font.sizes.textMedium};
  position: relative;
  opacity: 0.9;
  left: 30px;
  margin-bottom: ${spacings.space00};

  ::before {
    content: '!';
    display: flex;
    justify-content: center;
    font-size: ${font.sizes.textSmall};
    line-height: ${font.lineHeight.medium};
    position: absolute;
    color: ${popeyesSecondaryColors.light};
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 17.3px 10px;
    border-color: transparent transparent ${popeyesNeutral.neutral06}
      transparent;
    transform: translate(-150%, 30%);
  }
`;

const MediaModifier = {
  desktop: () => css``,
  mobile: () => css`
    @media (max-width: ${breakpoints.small}) {
      ${HeaderInfo} {
        h6 {
          margin-right: ${spacings.space05};
          text-align: initial;
        }
        h4,
        span {
          margin-right: ${spacings.space03};
        }
      }
    }
    @media (max-width: ${breakpoints.xSmall}) {
      ${Star} {
        transform: scale(0.8);
      }
      ${OpeningHoursList} {
        margin: ${spacings.space05} 0;
        p,
        li span {
          font-size: ${font.sizes.textMedium};
        }
      }
    }
  `,
};

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  padding-top: ${spacings.space03};

  > button {
    padding: 0 ${spacings.space04};
    margin-top: 10px !important;

    :last-child {
      margin-top: ${spacings.space01};
      img {
        transform: scale(1.2);
      }
    }
  }

  @media (max-width: ${breakpoints.intermediary}) {
    ${MediaModifier.mobile()}
  }
`;
